<template>
  <div :class="classes">
    <span :class="iconClass"/>
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'VAlert',
  props: {
    text: String,
    type: {
      type: String,
      default: 'success',
      validator(value) {
        return ['success'].includes(value);
      },
    },
  },

  computed: {
    classes() {
      return {
        'v-alert': true,
        'v-alert--success': this.type === 'success',
      };
    },

    iconClass() {
      return {
        'v-alert__icon': true,
        di: true,
        'di-icon-check': this.type === 'success',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.v-alert {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-success);
  color: #fff;
  height: 48px;
  border-radius: 4px;
  padding: 0 15px;

  &__icon {
    padding: 0 10px;
  }
}
</style>
